import axios from "axios";
import React from 'react';
import * as constants from "../../../util/constants";
import Alert from "../../common/Alert";
import Breadcrumb from "../../common/Breadcrumb";
import ButtonBack from "../../common/ButtonBack";
import ButtonSave from "../../common/ButtonSave";
import FieldBirthDate from "../../common/FieldBirthDate";
import FieldPhone from "../../common/FieldPhone";
import FieldText from "../../common/FieldText";
import Propertii from "../../common/Propertii";

class Profile extends Propertii {

    /**
     * Initialize the component.
     *
     * @param props - The properties of the component.
     */
    constructor(props) {

        super(props);

        this.state = {
            manager: {},
            validationList: [],
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    /**
     * Fetch the managers's data based on the ID provided in the session.
     */
    componentDidMount() {

        axios.get(`${constants.REACT_APP_HOST_API_URL}/manager/${this.props.userSession.sessionRole.id}`, {
            headers: this.generateRequestHeaders()
        }).then(response => {
            this.setState(prevState => ({
                ...prevState,
                manager: response.data
            }));
        }).catch(error => {
            this.handleValidation(error);
        });
    }

    /**
     * Handle the submission of the form.
     *
     * @param event - The event container.
     */
    handleSubmit(event) {
        event.preventDefault();

        axios.put(`${constants.REACT_APP_HOST_API_URL}/update`, this.state.manager, {
            headers: this.generateRequestHeaders()
        }).then(response => {
            this.setState({
                validationList: [{
                    alert: {
                        type: 'primary',
                        code: 'saved',
                        message: 'Changes have been saved'
                    },
                    fields: {},
                }],
            })
        }).catch(error => {
            this.handleValidation(error);
        });

        window.scrollTo(0, 0);
    }

    /**
     * Render the component.
     *
     * @returns {*} - The edit profile component for administrators.
     */
    render() {

        return(
            <div className="content-block">

                <div className="container">

                    <Breadcrumb parentPath="/manager/settings" parentPage="Settings" childPage="Edit Profile" />

                    <Alert validationList={this.state.validationList} />

                    <form onSubmit={this.handleSubmit}>

                        <div className="card">
                            <div className="card-header">
                                Profile Details
                            </div>
                            <div className="card-body">

                                <FieldText id="firstName" label="First Name" model="manager" parent={this} value={this.state.manager['firstName']} />

                                <FieldText id="lastName" label="Last Name" model="manager" parent={this} value={this.state.manager['lastName']} />

                                <FieldText id="email" label="Email" model="manager" type="email" parent={this} value={this.state.manager['email']} />

                                <FieldPhone id="phone" label="Phone" model="manager" parent={this} value={this.state.manager['phone']} optional={true} />

                                <FieldBirthDate id="birthDate" label="Birth Date" model="manager" parent={this} value={this.state.manager['birthDate']} optional={true} monthFirst={true}/>

                            </div>
                        </div>

                        <div className="row">
                            <div className="col text-right">

                                <ButtonBack path="/manager/settings" />
                                <ButtonSave />

                            </div>
                        </div>

                    </form>

                </div>
            </div>
        )
    };
}

export default Profile;